export const serialHasValidCharacters = (
  deviceModelNumber: string,
  serialNumber: string
): boolean => {
  // must pass in params
  if (!deviceModelNumber || !serialNumber) {
    return false
  }
  // if 1st character of the model is a number then digits regex else alphanumeric regex
  return !isNaN(Number(deviceModelNumber.charAt(0)))
    ? /^\d*$/.test(serialNumber)
    : /^[\da-zA-Z]*$/.test(serialNumber)
}

export const serialHasValidModelNumber = (
  deviceModelNumber: string,
  serialNumber: string
): boolean => {
  return serialNumber.toLowerCase().includes(deviceModelNumber)
}

export const serialHasValidLength = (serialNumber: string, serialLength: number): boolean => {
  return serialNumber.length === serialLength
}

export const serialIsValid = (
  deviceModelNumber: string,
  serialNumber: string,
  serialLength: number
): boolean => {
  return (
    serialHasValidLength(serialNumber, serialLength) &&
    serialHasValidCharacters(deviceModelNumber, serialNumber) &&
    serialHasValidModelNumber(deviceModelNumber, serialNumber)
  )
}
